// extracted by mini-css-extract-plugin
module.exports = {"block":"PhotoGallery_block__F5ZAo","title":"PhotoGallery_title__rI87M","photoGallery":"PhotoGallery_photoGallery__i9XZh"};